import {register} from '@shopify/theme-sections';

export default register('product-recommendations', {
  onLoad() {
    var loadProductRecommendationsIntoSection = function() {
      // Look for an element with class 'product-recommendations'
      var productRecommendationsSection = document.querySelector('.product-recommendations');
      if (productRecommendationsSection === null) {
        return;
      }
      // Find the container that we will append the products to
      var productRecommendationsProducts = productRecommendationsSection.querySelector(
        '.product-recommendations__products'
      );
      // Read product id from data attribute
      var productId = productRecommendationsSection.dataset.productId;
      // Read limit from data attribute
      var limit = productRecommendationsSection.dataset.limit;
      if (limit < 1) {
        return;
      }
      // Build request URL
      const rootUrl = window.theme.locale && window.theme.locale.primary ? '' : window.theme.locale.rootUrl;
      var requestUrl =
        rootUrl +
        '/recommendations/products?section_id=product-recommendations&limit=' +
        limit +
        '&product_id=' +
        productId;
      // Create request and submit it using Ajax
      var request = new XMLHttpRequest();
      request.open('GET', requestUrl);
      request.onload = function() {
        if (request.status >= 200 && request.status < 300) {
          var container = document.createElement('div');
          container.innerHTML = request.response;

          // Before we add the new recommendations we want to check if any of them already
          // exist in the custom defined ones.
          const productRecommendationNames = Array.from(
            productRecommendationsProducts.querySelectorAll('.product-recommendations__product')
          ).map(product => product.querySelector('.product-card__title').innerText.trim());

          const newRecommendedProducts = Array.from(
            container.querySelectorAll('.product-recommendations__product')
          ).filter(
            product =>
              !productRecommendationNames.includes(product.querySelector('.product-card__title').innerText.trim())
          );

          newRecommendedProducts.forEach(newRecommendedProduct => {
            productRecommendationsProducts.append(newRecommendedProduct);
          });
        }
      };
      request.send();
    };
    // If your section has theme settings, the theme editor
    // reloads the section as you edit those settings. When that happens, the
    // recommendations need to be fetched again.
    // See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
    document.addEventListener('shopify:section:load', function(event) {
      if (event.detail.sectionId === 'product-recommendations') {
        loadProductRecommendationsIntoSection();
      }
    });
    // Fetching the recommendations on page load
    loadProductRecommendationsIntoSection();
  },
});
